import React from "react";
import "../Styles/ParentBenefits.css";

const ParentBenefits = ({ scrollToSection }) => {
  return (
    <section className="parent-benefits">
      <div className="container">
        <div className="benefits-head reveal">
          <p className="eyebrow">What changes at home</p>
          <h2 className="section-title">“Mom, I finally get math!”</h2>
          <p className="section-lead">
            Struggling with a subject doesn’t mean they can’t learn it. We match your
            child with a tutor who teaches the way they learn — building real confidence,
            not just better grades.
          </p>
        </div>

        <div className="benefits-grid stagger">
          <article className="benefit-item reveal">
            <div className="benefit-icon" aria-hidden="true">
              1
            </div>
            <h3>Ends homework battles</h3>
            <p>
              Evenings feel calmer when your student has a clear plan and someone who can
              explain the hard parts without the tension.
            </p>
          </article>
          <article className="benefit-item reveal">
            <div className="benefit-icon" aria-hidden="true">
              2
            </div>
            <h3>Builds real confidence</h3>
            <p>
              Small wins add up. Students stop dreading class and start showing up with more
              certainty — and parents notice.
            </p>
          </article>
          <article className="benefit-item reveal">
            <div className="benefit-icon" aria-hidden="true">
              3
            </div>
            <h3>Faster, deeper understanding</h3>
            <p>
              We don’t just chase answers. We teach how to think through the material so
              progress sticks beyond one test.
            </p>
          </article>
        </div>

        <div className="path-grid reveal">
          <div className="path-col problems">
            <h3>If this sounds familiar…</h3>
            <ul>
              <li>Homework takes hours every night</li>
              <li>Tried tutor after tutor with no luck</li>
              <li>Confidence drops each report card</li>
            </ul>
          </div>
          <div className="path-arrow" aria-hidden="true">
            →
          </div>
          <div className="path-col solutions">
            <h3>Here’s what we do differently</h3>
            <ul>
              <li>Give them a tutor who “clicks”</li>
              <li>Match their true learning style</li>
              <li>Rebuild confidence with real wins</li>
            </ul>
          </div>
        </div>

        <div className="benefits-cta reveal">
          <button className="btn btn-primary" onClick={() => scrollToSection("contact")}>
            Book a Free Learning Assessment
          </button>
          <p>100% personalized tutor match · No obligation</p>
        </div>
      </div>
    </section>
  );
};

export default ParentBenefits;
